import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { AppLayoutToolbar } from '@src/components/sco/AppLayout/Toolbar/AppLayoutToolbar.tsx';
import React, { ReactNode } from 'react';
type EventsMainPanelProps = {
  children?: ReactNode;
};
export const EventsMainPanel = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AppLayoutToolbar />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.children) {
    t1 = <VStack flexGrow={1} gap={0} height="full" overflow="auto">{t0}<Box flexGrow={1} height="full" width="full">{props.children}</Box></VStack>;
    $[1] = props.children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};